<template>
	<el-card>
		<div slot="header" class="header">
			<h3>{{ assistant.name }}</h3>
			<p>{{ assistant.email }}</p>
		</div>
		<div v-if="! assistant.verified">
			<i class="el-icon-check"></i> Email invitation sent
		</div>
	</el-card>
</template>

<script>
export default {
	name: 'provider-assistant',

	props: {
		assistant: {
			type: Object,
			required: true
		}
	}
}
</script>
